import httpUtils from '../utils/http-utils';

const SERVICE_NAME = process.env.REACT_APP_API_ENDPOINT+"/mainContent";


const edit = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/edit", payload);
}

const search = () => {
    return httpUtils.post(SERVICE_NAME + "/search",{ condition: {} });
}

const mainContentApi = {
    edit,
    search
}

export default mainContentApi;